import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-store-selection-dialog-dt',
  templateUrl: './store-selection-dialog-dt.component.html',
  styleUrls: ['./store-selection-dialog-dt.component.scss'],
  standalone: false
})
export class StoreSelectionDialogDtComponent {
  // Returns true if all filtered stores are selected
  isAllSelected(): boolean {
    const stores = this.filteredStores;
    return stores.length > 0 && stores.every((s: any) => this.selectedStoreIds.has(s.id));
  }

  // Returns true if some but not all filtered stores are selected
  isIndeterminate(): boolean {
    const stores = this.filteredStores;
    const selectedCount = stores.filter((s: any) => this.selectedStoreIds.has(s.id)).length;
    return selectedCount > 0 && selectedCount < stores.length;
  }
  searchText = '';
  selectedOnly = false;
  private _includeSameStoreLY = false;
  get includeSameStoreLY() {
    return this._includeSameStoreLY;
  }
  
  set includeSameStoreLY(val: boolean) {
    this._includeSameStoreLY = val;
    if (val && Array.isArray(this.data?.lastYearSameWeekSalesInfo)) {
      const validShopIds = this.data.lastYearSameWeekSalesInfo.map((info: any) => Number(info.shop_id));
      // Remove any selected store not in LY set
      this.selectedStoreIds.forEach(id => {
        if (!validShopIds.includes(Number(id))) {
          this.selectedStoreIds.delete(id);
        }
      });
    }
  }
  stores: any[] = [];
  selectedStoreIds: Set<number> = new Set();
  tabIndex = 0;

  ngOnInit() {
    // No-op, but available for future use
  }

  ngOnChanges() {
    // No-op, but available for future use
  }

  onTabChange(index: number) {
    this.tabIndex = index;
    // Do not reset selectedStoreIds on tab change. Selection persists across tabs.
  }

  get allSelected(): boolean {
    return this.selectedStoreIds.size === this.stores.length && this.stores.length > 0;
  }
  set allSelected(val: boolean) {
    if (val) {
      this.stores.forEach(s => this.selectedStoreIds.add(s.id));
    } else {
      this.selectedStoreIds.clear();
    }
  }

  constructor(
    public dialogRef: MatDialogRef<StoreSelectionDialogDtComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Only include stores that are not DT
    this.stores = (data.stores || []).filter((s: any) => s.shop_type == 'DT');
    this.selectedStoreIds = new Set(data.selectedStoreIds || this.stores.map(s => s.id));
    this.includeSameStoreLY = !!data.includeSameStoreLY;
    // console.log(this.includeSameStoreLY)
  }

  get filteredStores() {
    let filtered = this.data.stores;
    if (this.tabIndex === 1) {
      filtered = filtered.filter((s:any) => s.shop_type === 'SUSHI');
    } else if (this.tabIndex === 2) {
      filtered = filtered.filter((s:any) => s.shop_type === 'BENTO');
    }
    // Do NOT filter out stores for LY, just disable them in UI
    if (this.searchText) {
      filtered = filtered.filter((s:any) => s.name.toLowerCase().includes(this.searchText.toLowerCase()));
    }
    if (this.selectedOnly) {
      filtered = filtered.filter((s:any) => this.selectedStoreIds.has(s.id));
    }
    return filtered;
  }

  isStoreDisabled(store: any): boolean {
    if (this.includeSameStoreLY && Array.isArray(this.data?.lastYearSameWeekSalesInfo)) {
      const validShopIds = this.data.lastYearSameWeekSalesInfo.map((info: any) => Number(info.shop_id));
      return !validShopIds.includes(Number(store.id));
    }
    return false;
  }

  toggleAll() {
    const stores = this.filteredStores;
    const allSelected = stores.every((s: any) => this.selectedStoreIds.has(s.id));
    if (allSelected) {
      // Deselect only the filtered stores
      stores.forEach((s: any) => this.selectedStoreIds.delete(s.id));
    } else {
      // Select all filtered stores
      stores.forEach((s: any) => this.selectedStoreIds.add(s.id));
    }

    // if (this.selectedStoreIds.size === this.stores.length) {
    //   this.selectedStoreIds.clear();
    // } else {
    //   this.stores.forEach(s => this.selectedStoreIds.add(s.id));
    // }
  }

  toggleStore(storeId: number) {
    if (this.selectedStoreIds.has(storeId)) {
      this.selectedStoreIds.delete(storeId);
    } else {
      this.selectedStoreIds.add(storeId);
    }
  }

  // applyFilter() {
  //   this.dialogRef.close({
  //     selectedStoreIds: Array.from(this.selectedStoreIds),
  //     includeSameStoreLY: this.includeSameStoreLY,
  //     selectedStores: this.includeSameStoreLY
  //       ? this.filteredStores.filter((s: any) => this.selectedStoreIds.has(s.id))
  //       : this.stores.filter(s => this.selectedStoreIds.has(s.id))
  //   });
  // }

  applyFilter() {
  let selectedStores;
  if (this.includeSameStoreLY) {
    // Only keep selected IDs that are in filteredStores
    const lyIds = new Set(this.filteredStores.map((s: any) => s.id));
    selectedStores = this.filteredStores.filter((s: any) => this.selectedStoreIds.has(s.id));
    // Optionally, update selectedStoreIds to only those in LY
    this.selectedStoreIds = new Set(selectedStores.map((s: any) => s.id));
  } else {
    selectedStores = this.stores.filter(s => this.selectedStoreIds.has(s.id));
  }
  this.dialogRef.close({
    selectedStoreIds: Array.from(this.selectedStoreIds),
    includeSameStoreLY: this.includeSameStoreLY,
    selectedStores
  });
}
  

  cancel() {
    this.dialogRef.close();
  }
}
